import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Button, Empty, Popconfirm, Table, Tag, Typography } from 'antd'
import PaginationContainer from '../../../components/Forms/Pagination'
import RatesTable from './RatesTable'

// Past saves, newest first. Each can be restored, which saves its values as the current rates.
const RatesHistory = ({ table, history, meta, currentId, onPage, onRestore, restoring }) => {
  /* eslint-disable react/display-name */
  const columns = [
    {
      title: 'Saved',
      key: 'when',
      render: (_, r) => moment(r.updatedAt).format('D MMM YYYY, HH:mm')
    },
    {
      title: 'By',
      key: 'who',
      render: (_, r) => (
        <>
          {r.savedBy || <Typography.Text type="secondary">Before the dashboard</Typography.Text>}
          {r.restoredFrom ? <Tag style={{ marginLeft: 8 }}>Restored</Tag> : null}
        </>
      )
    },
    {
      title: '',
      key: 'restore',
      align: 'right',
      render: (_, r) =>
        r.id === currentId ? (
          <Tag color="green">Current</Tag>
        ) : (
          <Popconfirm
            title="Make these the current rates?"
            okText="Restore"
            onConfirm={() => onRestore(r)}
          >
            <Button size="small" loading={restoring === r.id}>
              Restore
            </Button>
          </Popconfirm>
        )
    }
  ]
  /* eslint-enable react/display-name */

  return (
    <>
      <Table
        rowKey="id"
        dataSource={history}
        columns={columns}
        pagination={false}
        expandable={{
          // eslint-disable-next-line react/display-name
          expandedRowRender: r => <RatesTable table={table} rates={r} />
        }}
        locale={{ emptyText: <Empty description="No saves yet" /> }}
      />
      {history.length ? <PaginationContainer meta={meta} getData={onPage} /> : null}
    </>
  )
}

RatesHistory.propTypes = {
  table: PropTypes.oneOf(['banking', 'car']).isRequired,
  history: PropTypes.array.isRequired,
  meta: PropTypes.object,
  currentId: PropTypes.string,
  onPage: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
  restoring: PropTypes.string
}

export default RatesHistory
